import * as React from 'react';
import { Input } from '@progress/kendo-react-inputs';
import { FieldProps } from 'react-jsonschema-form-bs4';

export default class Address extends React.Component<FieldProps, any> {

    constructor(props: FieldProps) {
        super(props);
        this.state = { ...props.formData };
    }

    onChange(name: string) {
        return (event: React.ChangeEvent<HTMLInputElement>) => {
            this.setState({ [name]: !event.target.value ? null : event.target.value });
            setImmediate(() => this.props.onChange(this.state));
        };
    }

    public render() {
        const { Line1, Line2, City, State, Zip } = this.state;
        const required = this.props.schema.required || [];
        return <React.Fragment>
        <button type="button" className="btn btn-primary" data-toggle="modal" data-target={'#' + this.props.idSchema.$id}>
        {(Line1 || Line2 || City || State || Zip) ? Line1 : 'Set ' + this.props.schema.title + (this.props.required ? '*' : '')}
            <br/>
            {Line2}
            {Line2 && <br/>}
            {City}
            {' '}
            {State}
            {' '}
            {Zip}
        </button>
        <div className="modal fade k-form" id={this.props.idSchema.$id} tabIndex={-1} role="dialog" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{this.props.schema.title}</h5>
                        <button  type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        {this.props.schema.description && <p>{this.props.schema.description}</p>}
                        {typeof(this.props.schema.properties.Line1) === 'object' && <label className="k-form-field">
                            <span>{this.props.schema.properties.Line1.title || "Address Line 1"}{required.find(x => x === "Line1") && <span style={{ color: '#dc3545' }}>*</span>}</span>
                            <Input
                                type="text"
                                disabled={this.props.disabled}
                                readOnly={this.props.readonly}
                                placeholder={this.props.schema.properties.Line1.title || "Address Line 1"}
                                autoComplete="street-address address-Line1"
                                maxLength={40}
                                value={Line1 || ""}
                                onChange={this.onChange("Line1")}
                            />
                        </label>}
                        {typeof(this.props.schema.properties.Line2) === 'object' && <label className="k-form-field">
                            <span>{this.props.schema.properties.Line2.title || "Address Line 2"}{required.find(x => x === "Line2") && <span style={{ color: '#dc3545' }}>*</span>}</span>
                            <Input
                                type="text"
                                disabled={this.props.disabled}
                                readOnly={this.props.readonly}
                                placeholder={this.props.schema.properties.Line2.title || "Address Line 2"}
                                autoComplete="street-address address-Line2"
                                maxLength={40}
                                value={Line2 || ""}
                                onChange={this.onChange("Line2")}
                            />
                        </label>}
                        {typeof(this.props.schema.properties.City) === 'object' && <label className="k-form-field">
                            <span>{this.props.schema.properties.City.title || "City"}{required.find(x => x === "City") && <span style={{ color: '#dc3545' }}>*</span>}</span>
                            <Input
                                type="text"
                                disabled={this.props.disabled}
                                readOnly={this.props.readonly}
                                placeholder={this.props.schema.properties.City.title || "City"}
                                autoComplete="address-level2"
                                maxLength={40}
                                value={City || ""}
                                onChange={this.onChange("City")}
                            />
                        </label>}
                        {typeof(this.props.schema.properties.State) === 'object' && <label className="k-form-field">
                            <span>{this.props.schema.properties.State.title || "Province"}{required.find(x => x === "State") && <span style={{ color: '#dc3545' }}>*</span>}</span>
                            <Input
                                type="text"
                                disabled={this.props.disabled}
                                readOnly={this.props.readonly}
                                placeholder={this.props.schema.properties.State.title || "e.g. ON"}
                                autoComplete="address-level1"
                                maxLength={2}
                                value={State || ""}
                                onChange={this.onChange("State")}
                            />
                        </label>}
                        {typeof(this.props.schema.properties.Zip) === 'object' && <label className="k-form-field">
                            <span>{this.props.schema.properties.Zip.title || "Postal Code"}{required.find(x => x === "Zip") && <span style={{ color: '#dc3545' }}>*</span>}</span>
                            <Input
                                type="text"
                                disabled={this.props.disabled}
                                readOnly={this.props.readonly}
                                placeholder={this.props.schema.properties.Zip.title || "Postal Code"}
                                autoComplete="postal-code"
                                maxLength={10}
                                value={Zip || ""}
                                onChange={this.onChange("Zip")}
                            />
                        </label>}
                        <div className="modal-footer">
                            <button type="button" className="btn btn-primary" data-dismiss="modal">Done</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {this.props.errorSchema && <ul className="error-detail bs-callout bs-callout-info">
            {this.props.errorSchema.hasOwnProperty('Line1') &&
                <li className="text-danger">Address Line 1 is a required field</li>}
            {this.props.errorSchema.hasOwnProperty('City') &&
                <li className="text-danger">City is a required field</li>}
            {this.props.errorSchema.hasOwnProperty('State') &&
                <li className="text-danger">State is a required field</li>}
            {this.props.errorSchema.hasOwnProperty('Zip') &&
                <li className="text-danger">Zip is a required field</li>}
        </ul>}
    </React.Fragment>;
    }
}
